import { createLogic } from "redux-logic";
import { type HistoryEventType, HISTORY_EVENT } from "../../../../common-deprecated/redux/actions/UtilActions";
import { queryStringToObject } from "../../../../common-deprecated/utils";
import { setStep } from "../actions/UscNavActions";
import type { UscLogicType } from "../store";
import type { UscNavStepEnum } from "../../utils/constants";

const historyLogic = (createLogic as UscLogicType<HistoryEventType>)({
    type: HISTORY_EVENT,

    validate({ action }, allow, reject) {
        // For now we're only acting on on POP action events because we have no need to listen to PUSH (no state updates).
        if (action.actionType === "POP") allow(action);
        else (reject as () => void)();
    },

    process({ action, getState }, dispatch, done) {
        const { location } = action;
        const query = queryStringToObject(location.search);

        const { nav } = getState();

        // Update step when going back in browser if the step is different
        if (query.uscStep && query.uscStep !== nav.step) {
            dispatch(setStep(query.uscStep as UscNavStepEnum));
        }
        done();
    },
});

export default [historyLogic];
